import React, { useContext, useState } from 'react';
import {
  Box,
  Paper,
  // Avatar,
  Typography,
  Stack,
  Button,
  // Chip,
  Divider,
  IconButton,
  Tooltip,
  // Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { FaArrowLeft, FaEdit, FaShieldAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import UpdateProfile from './forms/UpdateProfile'; // Modal component for editing profile
import { AuthContext } from '../auth/AuthContext';
import ProfileDetails from './ProfileDetails';

// Example user data (replace with actual fetched data)



export default function Profile() {
  const {currentUser} = useContext(AuthContext)
  const [editOpen, setEditOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  if (!currentUser) {
    return (
      <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          Loading profile...
        </Typography>
      </Box>
    );
  }
  // console.log(currentUser)

  return (
   <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e0f7fa 0%, #f0fdf4 100%)',
        py: { xs: 2, md: 6 },
        px: { xs: 1, md: 0 },
      }}
    >
      <Box maxWidth={600} mx="auto">
        <Paper
          elevation={4}
          sx={{
            borderRadius: 5,
            p: { xs: 2, sm: 4 },
            background: 'linear-gradient(120deg, #e8f5e9 60%, #b2dfdb 100%)',
            boxShadow: '0 8px 32px 0 rgba(34,139,34,0.12)',
            position: 'relative',
          }}
        >
          {/* Back Button */}
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              position: 'absolute',
              top: 18,
              left: 18,
              color: '#1976d2',
              background: '#fff',
              border: '2px solid #1976d2',
              '&:hover': { background: '#e3f2fd' },
              zIndex: 2,
            }}
            size="large"
          >
            <FaArrowLeft />
          </IconButton>

          {/* Edit Button */}
          <Tooltip title="Edit Profile" arrow>
            <IconButton
              onClick={() => setEditOpen(true)}
              sx={{
                position: 'absolute',
                top: 18,
                right: 18,
                color: '#388e3c',
                background: '#fff',
                border: '2px solid #388e3c',
                '&:hover': { background: '#c8e6c9' },
                zIndex: 2,
              }}
              size="large"
            >
              <FaEdit />
            </IconButton>
          </Tooltip>

          {/* DETAILs  */}
          <ProfileDetails user={currentUser} />
          <Divider sx={{ my: 3, borderColor: '#b2dfdb' }} />

          {/* Actions */}
          <Stack direction={isMobile ? "column" : "row"} spacing={2} justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              color="success"
              sx={{
                fontWeight: 'bold',
                textTransform: 'none',
                borderRadius: 2,
                px: 4,
                boxShadow: 2,
                bgcolor: '#43a047',
                '&:hover': { bgcolor: '#388e3c' },
              }}
              onClick={() => setEditOpen(true)}
              startIcon={<FaEdit />}
            >
              Edit Profile
            </Button>
            <Button
              variant="outlined"
              color="primary"
              sx={{
                fontWeight: 'bold',
                textTransform: 'none',
                borderRadius: 2,
                px: 4,
                boxShadow: 2,
                bgcolor: '#e3f2fd',
                '&:hover': { bgcolor: '#bbdefb' },
              }}
              onClick={() => navigate('/change-password')}
              startIcon={<FaShieldAlt />}
            >
              Change Password
            </Button>
          </Stack>
        </Paper>
      </Box>

      {/* Update Profile Modal */}
      <UpdateProfile open={editOpen} onClose={() => setEditOpen(false)} user={currentUser} />
    </Box>
  );
}